
import initialState from "toolConstants/classroomDesigner/initialState";
import constants from "./constants";
import { ceil } from "lodash";

export const resetArea = (container, parameter = null) => {
  const activeArea = container.areas[container.activeTab];
  const initState = initialState.area();

  // reset the ceiling tiles
  const { tile } = activeArea.ceilingTiles;
  const ceilingTiles = initState.ceilingTiles;
  
  // If tiles were active and dimensions changed, recalculate the quantity for the new room size
  if (parameter === 'dimensions' && tile && tile !== "no_ceiling_tiles") {
    const tileDimensions = constants.ceilingTiles?.[tile];
    if (tileDimensions && tileDimensions.x > 0 && tileDimensions.y > 0) {
      const { length, width } = activeArea.dimensions;
      // Calculate tiles needed to fully cover the room with centered grid
      // Add one extra tile to ensure full coverage when grid is centered
      const newQtyX = ceil(length / tileDimensions.x) + 1;
      const newQtyY = ceil(width / tileDimensions.y) + 1;
      
      activeArea.ceilingTiles = { 
        ...ceilingTiles, 
        tile: tile,
        qty: { x: newQtyX, y: newQtyY },
        transform: { x: 0, y: 0, a: 0 }, // Reset to centered position
        checked: [] // Clear any checked tiles as they won't align with new grid
      };
    } else {
      activeArea.ceilingTiles = {...ceilingTiles, tile: tile};
    }
  } else {
    activeArea.ceilingTiles = {...ceilingTiles, tile: tile};
  }

}